import styled from 'styled-components';
import copyIcon from 'assets/img/copy.svg';
import copySecondaryIcon from 'assets/img/copy-secondary.svg';
import { useState } from 'react';

function insertLineBreaks(text) {
  if (!text) return;
  return text.replaceAll(/\r?\n/g, '<br />');
}

export const ReportSummary = ({ summary, show }) => {
  const [isCopied, setCopied] = useState(false);

  function copyToClipboard(text) {
    setCopied(true);
    setTimeout(() => setCopied(false), 1700);
    navigator.clipboard.writeText(text);
  }

  const formattedText = insertLineBreaks(summary);

  const staticHtmlText = "<br>** Mean FBS is estimated from 5-9 timeblock **" 

  if (!show) return null;

  return (
    <StyledReportSummary>
      <p className="summary-title">Report Summary</p>
      <span>
        <div className="summary-divider" />
      </span>
      <div>
        <p
          dir="ltr"
          className="summary-text"
          dangerouslySetInnerHTML={{ __html: formattedText + staticHtmlText}}
        />
      </div>
      <CopyButton
        onClick={() => !isCopied && copyToClipboard(summary)}
        isCopied={isCopied}
      >
        <img src={isCopied ? copySecondaryIcon : copyIcon} />
        <p dir="ltr" className="copy-text">
          {isCopied ? 'Copied !' : 'Copy To Clipboard'}
        </p>
      </CopyButton>
    </StyledReportSummary>
  );
};

const CopyButton = styled.div`
  .copy-text {
    white-space: nowrap;
    color: ${({ isCopied }) => (isCopied ? `#3CC0C3` : `#753cbe`)};
    width: 100%;
    font-size: 16px;
  }
  cursor: pointer;
  display: flex;
  font-weight: 700;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 22px;
  width: auto;
  min-width: 200px;
  height: 48px;
  border-radius: 16px;
  border-width: 1px;
  border-style: solid;
  padding: 12px 12px 12px 18px;
  border-color: ${({ isCopied }) => (isCopied ? `#3CC0C3` : `#753cbe`)};
  @media screen and (min-width: 1024px) {
    margin-top: 45px;
  }
`;

const StyledReportSummary = styled.div`
  padding: 20px 0 25px;
  width: 100%;
  border-radius: 16px;
  background: #ffffff;
  display: grid;
  place-items: center;
  p {
    color: #753cbe;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    padding:25px;
  }
  .summary-divider {
    width: 250px;
    height: 1px;
    background-color: #d9d9d9;
    margin: 10px 0 14px;
  }
  .summary-text {
    color: #58595b;
    font-size: 16px;
    line-height: 24.26px;
    text-align: left;
    font-weight: 400;
    letter-spacing: 1px;
  }

  @media screen and (min-width: 1024px) {
    padding: 0 0 30px;
    .summary-title {
      font-size: 24px;
    }
    .summary-divider {
      height: 2px;
      background-color: #d8d8d8;
      margin: 20px 0 30px;
    }
  }
`;
